function randomPointsSpace(qty, tries){
	let points = [];

	for(let i=0; i<qty; i++){
		let candidates = [];
		for(let j=0; j<tries; j++){
			candidates.push(getCandidate());
		} 
		points.push(getBestCandidate(points, candidates));
	}

	return points;
}

function getCandidate(){
	return {x: Math.random(), y: Math.random(), z: Math.random()};
}

function getBestCandidate(members, candidates){
	let max = 0,
		selected;

	for(let k=0; k<candidates.length; k++){
		let min = 1,
			c = candidates[k];

		for(let l=0; l<members.length; l++){
			let m = members[l];
			let dist = Math.sqrt( squareIt(c.x-m.x) + squareIt(c.y-m.y) + squareIt(c.z-m.z) ) - m.r/2;

			if(dist < min){
				min = dist;
			}
		}

		if(min > max){
			max = min;
			selected = c;
			selected.r = min/2;
		}
	}

	return selected;
}

function squareIt(number) {
   return number * number;
}

export default randomPointsSpace;